import { render, staticRenderFns } from "./Mepandes.vue?vue&type=template&id=c96c21ae&scoped=true&"
import script from "./Mepandes.vue?vue&type=script&lang=js&"
export * from "./Mepandes.vue?vue&type=script&lang=js&"
import style0 from "./Mepandes.vue?vue&type=style&index=0&id=c96c21ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96c21ae",
  null
  
)

export default component.exports